import { Flex, Text } from '@chakra-ui/react';
import FormFieldSet from '../../FormFieldSet';
import useCurrentContextId from 'src/hooks/useCurrentContextId';
import CopyrightAndPublicationAgreement from './CopyrightAndPublicationAgreement';
import { useSubmissionContextData } from '../../../contexts/SubmissionContextProvider';
import CopyrightAndPublicationAgreementSubmittingAuthorOnly from './CopyrightAndPublicationAgreementSubmittingAuthorOnly';
import { isFormConfigured } from '../../../utils/formConfig';

const CopyrightAndLicensingTab = () => {
  const submissionContextId = useCurrentContextId() ?? '';
  const { submissionContext } = useSubmissionContextData();
  const type = submissionContext?.config?.authorCopyrightModel;

  if (!isFormConfigured(type)) {
    return (
      <Flex flexDirection="column" gap={8}>
        <Text textStyle="headingSection">Copyright and Licensing</Text>
        <Text>No form available at the moment</Text>
      </Flex>
    );
  }

  return (
    <Flex flexDirection="column" gap={8}>
      <Text textStyle="headingSection">Copyright and Licensing </Text>

      {type === 'SubmittingAuthorOnly' ? (
        <CopyrightAndPublicationAgreementSubmittingAuthorOnly />
      ) : (
        <>
          {/* Copyright and Publication Agreement */}
          <CopyrightAndPublicationAgreement />

          {/* Copyright and Open Access */}
          <FormFieldSet
            label="Copyright and Open Access"
            fieldNames={[
              'CopyrightType',
              'CopyrightHolder',
              'OpenAccessLicenseType'
            ]}
            submissionContextId={submissionContextId}
            attentionBannerText="Selecting certain options in this section will reveal additional required fields. Ensure all relevant fields are completed before saving."
          />

          {/* Transformative Agreement */}
          <FormFieldSet
            label="Transformative Agreement"
            fieldNames={[
              'TransformativeAgreementStatus',
              'TransformativeAgreementWaiverPercentage',
              'TransformativeAgreementInstitution',
              'TransformativeAgreementDateRequested',
              'TransformativeAgreementDateChased'
            ]}
            submissionContextId={submissionContextId}
          />

          {/* Waiver */}
          <FormFieldSet
            label="Waiver"
            fieldNames={[
              'OpenAccessWaiverContact',
              'OpenAccessWaiverReason',
              'OpenAccessWaiverPercentage',
              'OpenAccessWaiverComment'
            ]}
            submissionContextId={submissionContextId}
          />
        </>
      )}
    </Flex>
  );
};

export default CopyrightAndLicensingTab;
